export default __webpack_public_path__ + "static/media/iowa.8cba4492.jpg";